import React from 'react'
import styled from 'styled-components'

import Logo from './Logo'
import SearchField from './SearchField'
import MoreMenu from './MoreMenu'
import MenuItem from './MenuItem'
import BurgerMenu from './MoreMenu'

const Content = styled.div`
  display: flex;
  ${props => (props.searchField ? 'flex-wrap: wrap' : '')};
  justify-content: space-between;
`

const Menu = styled.div`
  display: flex;
`

const SearchFieldWrapper = styled.div`
  width: 100%;
  margin: -12px 20px 20px;
`

const SmallHeader = ({ noBurger, menu, moreMenu, searchField }) => (
  <Content searchField={searchField}>
    <Logo />
    {noBurger ? (
      <Menu>
        {menu.map((menuItem, i) => <MenuItem key={i} {...menuItem} />)}
        {moreMenu && moreMenu.length > 0 && <MoreMenu items={moreMenu} />}
      </Menu>
    ) : (
      <BurgerMenu
        items={[].concat(menu).concat(moreMenu)}
        image="/icons/hamburger.svg"
      />
    )}
    {searchField && (
      <SearchFieldWrapper>
        <SearchField />
      </SearchFieldWrapper>
    )}
  </Content>
)

export default SmallHeader



// WEBPACK FOOTER //
// ./src/components/Header/SmallHeader.js